import { purchaseOrdersModuleNamespace } from '../../common/';
import { SelectedItemKey } from './types';

const namespace = purchaseOrdersModuleNamespace;

export const SET_SELECTED_ROW_KEYS_TO_PURCHASE =
  `${namespace}/SET_SELECTED_ROW_KEYS_TO_PURCHASE` as const;
export const setSelectedRowKeysToPurchase = (items: SelectedItemKey[]) => ({
  type: SET_SELECTED_ROW_KEYS_TO_PURCHASE,
  payload: items,
});
